'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackSubscriptionSaleConfirmation = exports.trackFreeBetsTap = exports.trackAllOffers = exports.trackCardIndexClick = exports.trackRacecardOfferButtonClicked = exports.trackRacecardOfferAccordionClosed = exports.trackRacecardOfferAccordionOpened = exports.trackRaceMatrixClick = exports.trackVoucherCodeRemoved = exports.trackVoucherCodeEntered = exports.trackVoucherCodeDenied = exports.trackVoucherCodeApplied = exports.trackUpgradeStarted = exports.trackUpgradeCompleted = exports.trackSubscriptionUpgraded = exports.trackSubscriptionViewed = exports.trackSubscriptionStarted = exports.trackSubscriptionSaleAttempt = exports.trackSubscriptionSale = exports.trackSubscriptionDetailsViewed = exports.trackSubscriptionDetailsCompleted = exports.trackSubscriptionCompleted = exports.trackRemoveSelectionButtonClick = exports.trackRegister = exports.trackQuickStakeButtonsClick = exports.trackPreferencesUpdate = exports.trackBetslipErrorMessage = exports.trackPlaceBet = exports.trackOrderCompleted = exports.trackBookmakerRegistrationTap = exports.trackOfferAccordion = exports.trackNavigationClick = exports.trackBookmakerOfferClaimButtonClick = exports.trackBookmakerLoginSuccess = exports.trackBookmakerLoginFailure = exports.trackBookmakerLoginAttempt = exports.trackCancelBetButtonClick = exports.trackLogin = exports.trackHorseTrackerSettings = exports.trackFooterClick = exports.trackEmailVerification = exports.trackDiscardSlipButtonClick = exports.trackCardCustomisation = exports.trackBookmakerRegister = exports.trackBookmakerLogin = exports.trackBettingOfferClick = exports.trackBetReceipt = exports.trackBetButtonClick = exports.trackBarrierUltimateSubscribe = exports.trackBarrierUltimateShow = exports.trackBarrierUltimateOnlyUpgrade = exports.trackBarrierUltimateOnlyShow = exports.trackBarrierInteraction = exports.trackBarrierSignInShow = exports.trackBarrierSignInPassword = exports.trackBarrierSignIn = exports.trackBarrierShow = exports.trackBarrierEssentialSubscribe = exports.trackBarrierEssentialShow = exports.identifySubscriptionSale = exports.identifyRegister = exports.identifyLogin = exports.clearCommonTraits = exports.setCommonTraits = exports.getCommonTraits = exports.enableDebug = exports.enableLogging = exports.alias = exports.identify = exports.page = exports.track = undefined;

var _events = require('./events');

Object.keys(_events).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _events[key];
        }
    });
});

var _traits = require('./traits');

Object.keys(_traits).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _traits[key];
        }
    });
});

var _registerEvents = require('./registerEvents');

var _registerEvents2 = _interopRequireDefault(_registerEvents);

var _setUTMParams = require('./utils/utm/setUTMParams');

var _setUTMParams2 = _interopRequireDefault(_setUTMParams);

var _enableLogging = require('./utils/enableLogging');

var _enableLogging2 = _interopRequireDefault(_enableLogging);

var _enableDebug = require('./utils/enableDebug');

var _enableDebug2 = _interopRequireDefault(_enableDebug);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _page = require('./utils/page');

var _page2 = _interopRequireDefault(_page);

var _identify = require('./utils/identify');

var _identify2 = _interopRequireDefault(_identify);

var _alias = require('./utils/alias');

var _alias2 = _interopRequireDefault(_alias);

var _commonTraits = require('./utils/commonTraits');

var _identifyLogin = require('./identifyLogin');

var _identifyLogin2 = _interopRequireDefault(_identifyLogin);

var _identifyRegister = require('./identifyRegister');

var _identifyRegister2 = _interopRequireDefault(_identifyRegister);

var _identifySubscriptionSale = require('./identifySubscriptionSale');

var _identifySubscriptionSale2 = _interopRequireDefault(_identifySubscriptionSale);

var _trackBarrierEssentialShow = require('./trackBarrierEssentialShow');

var _trackBarrierEssentialShow2 = _interopRequireDefault(_trackBarrierEssentialShow);

var _trackBarrierEssentialSubscribe = require('./trackBarrierEssentialSubscribe');

var _trackBarrierEssentialSubscribe2 = _interopRequireDefault(_trackBarrierEssentialSubscribe);

var _trackBarrierShow = require('./trackBarrierShow');

var _trackBarrierShow2 = _interopRequireDefault(_trackBarrierShow);

var _trackBarrierSignIn = require('./trackBarrierSignIn');

var _trackBarrierSignIn2 = _interopRequireDefault(_trackBarrierSignIn);

var _trackBarrierSignInPassword = require('./trackBarrierSignInPassword');

var _trackBarrierSignInPassword2 = _interopRequireDefault(_trackBarrierSignInPassword);

var _trackBarrierSignInShow = require('./trackBarrierSignInShow');

var _trackBarrierSignInShow2 = _interopRequireDefault(_trackBarrierSignInShow);

var _trackBarrierInteraction = require('./trackBarrierInteraction');

var _trackBarrierInteraction2 = _interopRequireDefault(_trackBarrierInteraction);

var _trackBarrierUltimateOnlyShow = require('./trackBarrierUltimateOnlyShow');

var _trackBarrierUltimateOnlyShow2 = _interopRequireDefault(_trackBarrierUltimateOnlyShow);

var _trackBarrierUltimateOnlyUpgrade = require('./trackBarrierUltimateOnlyUpgrade');

var _trackBarrierUltimateOnlyUpgrade2 = _interopRequireDefault(_trackBarrierUltimateOnlyUpgrade);

var _trackBarrierUltimateShow = require('./trackBarrierUltimateShow');

var _trackBarrierUltimateShow2 = _interopRequireDefault(_trackBarrierUltimateShow);

var _trackBarrierUltimateSubscribe = require('./trackBarrierUltimateSubscribe');

var _trackBarrierUltimateSubscribe2 = _interopRequireDefault(_trackBarrierUltimateSubscribe);

var _trackBetButtonClick = require('./trackBetButtonClick');

var _trackBetButtonClick2 = _interopRequireDefault(_trackBetButtonClick);

var _trackBetReceipt = require('./trackBetReceipt');

var _trackBetReceipt2 = _interopRequireDefault(_trackBetReceipt);

var _trackBettingOfferClick = require('./trackBettingOfferClick');

var _trackBettingOfferClick2 = _interopRequireDefault(_trackBettingOfferClick);

var _trackBookmakerLogin = require('./trackBookmakerLogin');

var _trackBookmakerLogin2 = _interopRequireDefault(_trackBookmakerLogin);

var _trackBookmakerRegister = require('./trackBookmakerRegister');

var _trackBookmakerRegister2 = _interopRequireDefault(_trackBookmakerRegister);

var _trackBookmakerLoginAttempt = require('./trackBookmakerLoginAttempt');

var _trackBookmakerLoginAttempt2 = _interopRequireDefault(_trackBookmakerLoginAttempt);

var _trackBookmakerLoginFailure = require('./trackBookmakerLoginFailure');

var _trackBookmakerLoginFailure2 = _interopRequireDefault(_trackBookmakerLoginFailure);

var _trackBookmakerLoginSuccess = require('./trackBookmakerLoginSuccess');

var _trackBookmakerLoginSuccess2 = _interopRequireDefault(_trackBookmakerLoginSuccess);

var _trackBookmakerOfferClaimButtonClick = require('./trackBookmakerOfferClaimButtonClick');

var _trackBookmakerOfferClaimButtonClick2 = _interopRequireDefault(_trackBookmakerOfferClaimButtonClick);

var _trackLogin = require('./trackLogin');

var _trackLogin2 = _interopRequireDefault(_trackLogin);

var _trackCancelBetButtonClick = require('./trackCancelBetButtonClick');

var _trackCancelBetButtonClick2 = _interopRequireDefault(_trackCancelBetButtonClick);

var _trackCardCustomisation = require('./trackCardCustomisation');

var _trackCardCustomisation2 = _interopRequireDefault(_trackCardCustomisation);

var _trackDiscardSlipButtonClick = require('./trackDiscardSlipButtonClick');

var _trackDiscardSlipButtonClick2 = _interopRequireDefault(_trackDiscardSlipButtonClick);

var _trackHorseTrackerSettings = require('./trackHorseTrackerSettings');

var _trackHorseTrackerSettings2 = _interopRequireDefault(_trackHorseTrackerSettings);

var _trackEmailVerification = require('./trackEmailVerification');

var _trackEmailVerification2 = _interopRequireDefault(_trackEmailVerification);

var _trackNavigationClick = require('./trackNavigationClick');

var _trackNavigationClick2 = _interopRequireDefault(_trackNavigationClick);

var _trackFooterClick = require('./trackFooterClick');

var _trackFooterClick2 = _interopRequireDefault(_trackFooterClick);

var _trackOfferAccordion = require('./trackOfferAccordion');

var _trackOfferAccordion2 = _interopRequireDefault(_trackOfferAccordion);

var _trackBookmakerRegistrationTap = require('./trackBookmakerRegistrationTap');

var _trackBookmakerRegistrationTap2 = _interopRequireDefault(_trackBookmakerRegistrationTap);

var _trackOrderCompleted = require('./trackOrderCompleted');

var _trackOrderCompleted2 = _interopRequireDefault(_trackOrderCompleted);

var _trackPlaceBet = require('./trackPlaceBet');

var _trackPlaceBet2 = _interopRequireDefault(_trackPlaceBet);

var _trackBetslipErrorMessage = require('./trackBetslipErrorMessage');

var _trackBetslipErrorMessage2 = _interopRequireDefault(_trackBetslipErrorMessage);

var _trackPreferencesUpdate = require('./trackPreferencesUpdate');

var _trackPreferencesUpdate2 = _interopRequireDefault(_trackPreferencesUpdate);

var _trackQuickStakeButtonsClick = require('./trackQuickStakeButtonsClick');

var _trackQuickStakeButtonsClick2 = _interopRequireDefault(_trackQuickStakeButtonsClick);

var _trackRegister = require('./trackRegister');

var _trackRegister2 = _interopRequireDefault(_trackRegister);

var _trackRemoveSelectionButtonClick = require('./trackRemoveSelectionButtonClick');

var _trackRemoveSelectionButtonClick2 = _interopRequireDefault(_trackRemoveSelectionButtonClick);

var _trackSubscriptionCompleted = require('./trackSubscriptionCompleted');

var _trackSubscriptionCompleted2 = _interopRequireDefault(_trackSubscriptionCompleted);

var _trackSubscriptionDetailsCompleted = require('./trackSubscriptionDetailsCompleted');

var _trackSubscriptionDetailsCompleted2 = _interopRequireDefault(_trackSubscriptionDetailsCompleted);

var _trackSubscriptionDetailsViewed = require('./trackSubscriptionDetailsViewed');

var _trackSubscriptionDetailsViewed2 = _interopRequireDefault(_trackSubscriptionDetailsViewed);

var _trackSubscriptionSale = require('./trackSubscriptionSale');

var _trackSubscriptionSale2 = _interopRequireDefault(_trackSubscriptionSale);

var _trackSubscriptionSaleAttempt = require('./trackSubscriptionSaleAttempt');

var _trackSubscriptionSaleAttempt2 = _interopRequireDefault(_trackSubscriptionSaleAttempt);

var _trackSubscriptionStarted = require('./trackSubscriptionStarted');

var _trackSubscriptionStarted2 = _interopRequireDefault(_trackSubscriptionStarted);

var _trackSubscriptionViewed = require('./trackSubscriptionViewed');

var _trackSubscriptionViewed2 = _interopRequireDefault(_trackSubscriptionViewed);

var _trackSubscriptionUpgraded = require('./trackSubscriptionUpgraded');

var _trackSubscriptionUpgraded2 = _interopRequireDefault(_trackSubscriptionUpgraded);

var _trackUpgradeCompleted = require('./trackUpgradeCompleted');

var _trackUpgradeCompleted2 = _interopRequireDefault(_trackUpgradeCompleted);

var _trackUpgradeStarted = require('./trackUpgradeStarted');

var _trackUpgradeStarted2 = _interopRequireDefault(_trackUpgradeStarted);

var _trackVoucherCodeApplied = require('./trackVoucherCodeApplied');

var _trackVoucherCodeApplied2 = _interopRequireDefault(_trackVoucherCodeApplied);

var _trackVoucherCodeDenied = require('./trackVoucherCodeDenied');

var _trackVoucherCodeDenied2 = _interopRequireDefault(_trackVoucherCodeDenied);

var _trackVoucherCodeEntered = require('./trackVoucherCodeEntered');

var _trackVoucherCodeEntered2 = _interopRequireDefault(_trackVoucherCodeEntered);

var _trackVoucherCodeRemoved = require('./trackVoucherCodeRemoved');

var _trackVoucherCodeRemoved2 = _interopRequireDefault(_trackVoucherCodeRemoved);

var _trackRaceMatrixClick = require('./trackRaceMatrixClick');

var _trackRaceMatrixClick2 = _interopRequireDefault(_trackRaceMatrixClick);

var _trackRacecardOfferAccordionOpened = require('./trackRacecardOfferAccordionOpened');

var _trackRacecardOfferAccordionOpened2 = _interopRequireDefault(_trackRacecardOfferAccordionOpened);

var _trackRacecardOfferAccordionClosed = require('./trackRacecardOfferAccordionClosed');

var _trackRacecardOfferAccordionClosed2 = _interopRequireDefault(_trackRacecardOfferAccordionClosed);

var _trackRacecardOfferButtonClicked = require('./trackRacecardOfferButtonClicked');

var _trackRacecardOfferButtonClicked2 = _interopRequireDefault(_trackRacecardOfferButtonClicked);

var _trackCardIndexClick = require('./trackCardIndexClick');

var _trackCardIndexClick2 = _interopRequireDefault(_trackCardIndexClick);

var _trackAllOffers = require('./trackAllOffers');

var _trackAllOffers2 = _interopRequireDefault(_trackAllOffers);

var _trackFreeBetsTap = require('./trackFreeBetsTap');

var _trackFreeBetsTap2 = _interopRequireDefault(_trackFreeBetsTap);

var _trackSubscriptionSaleConfirmation = require('./trackSubscriptionSaleConfirmation');

var _trackSubscriptionSaleConfirmation2 = _interopRequireDefault(_trackSubscriptionSaleConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _registerEvents2.default)(); /**
                                  * Helper for using segmentio API.
                                  * Provides public interface for calling segmentio
                                  * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
                                  * @author Serhii Kotyk <serhii.kotyk@racingpost.com>
                                  */

(0, _setUTMParams2.default)(location.search.substr(1));

exports.track = _track2.default;
exports.page = _page2.default;
exports.identify = _identify2.default;
exports.alias = _alias2.default;
exports.enableLogging = _enableLogging2.default;
exports.enableDebug = _enableDebug2.default;
exports.getCommonTraits = _commonTraits.getCommonTraits;
exports.setCommonTraits = _commonTraits.setCommonTraits;
exports.clearCommonTraits = _commonTraits.clearCommonTraits;
exports.identifyLogin = _identifyLogin2.default;
exports.identifyRegister = _identifyRegister2.default;
exports.identifySubscriptionSale = _identifySubscriptionSale2.default;
exports.trackBarrierEssentialShow = _trackBarrierEssentialShow2.default;
exports.trackBarrierEssentialSubscribe = _trackBarrierEssentialSubscribe2.default;
exports.trackBarrierShow = _trackBarrierShow2.default;
exports.trackBarrierSignIn = _trackBarrierSignIn2.default;
exports.trackBarrierSignInPassword = _trackBarrierSignInPassword2.default;
exports.trackBarrierSignInShow = _trackBarrierSignInShow2.default;
exports.trackBarrierInteraction = _trackBarrierInteraction2.default;
exports.trackBarrierUltimateOnlyShow = _trackBarrierUltimateOnlyShow2.default;
exports.trackBarrierUltimateOnlyUpgrade = _trackBarrierUltimateOnlyUpgrade2.default;
exports.trackBarrierUltimateShow = _trackBarrierUltimateShow2.default;
exports.trackBarrierUltimateSubscribe = _trackBarrierUltimateSubscribe2.default;
exports.trackBetButtonClick = _trackBetButtonClick2.default;
exports.trackBetReceipt = _trackBetReceipt2.default;
exports.trackBettingOfferClick = _trackBettingOfferClick2.default;
exports.trackBookmakerLogin = _trackBookmakerLogin2.default;
exports.trackBookmakerRegister = _trackBookmakerRegister2.default;
exports.trackCardCustomisation = _trackCardCustomisation2.default;
exports.trackDiscardSlipButtonClick = _trackDiscardSlipButtonClick2.default;
exports.trackEmailVerification = _trackEmailVerification2.default;
exports.trackFooterClick = _trackFooterClick2.default;
exports.trackHorseTrackerSettings = _trackHorseTrackerSettings2.default;
exports.trackLogin = _trackLogin2.default;
exports.trackCancelBetButtonClick = _trackCancelBetButtonClick2.default;
exports.trackBookmakerLoginAttempt = _trackBookmakerLoginAttempt2.default;
exports.trackBookmakerLoginFailure = _trackBookmakerLoginFailure2.default;
exports.trackBookmakerLoginSuccess = _trackBookmakerLoginSuccess2.default;
exports.trackBookmakerOfferClaimButtonClick = _trackBookmakerOfferClaimButtonClick2.default;
exports.trackNavigationClick = _trackNavigationClick2.default;
exports.trackOfferAccordion = _trackOfferAccordion2.default;
exports.trackBookmakerRegistrationTap = _trackBookmakerRegistrationTap2.default;
exports.trackOrderCompleted = _trackOrderCompleted2.default;
exports.trackPlaceBet = _trackPlaceBet2.default;
exports.trackBetslipErrorMessage = _trackBetslipErrorMessage2.default;
exports.trackPreferencesUpdate = _trackPreferencesUpdate2.default;
exports.trackQuickStakeButtonsClick = _trackQuickStakeButtonsClick2.default;
exports.trackRegister = _trackRegister2.default;
exports.trackRemoveSelectionButtonClick = _trackRemoveSelectionButtonClick2.default;
exports.trackSubscriptionCompleted = _trackSubscriptionCompleted2.default;
exports.trackSubscriptionDetailsCompleted = _trackSubscriptionDetailsCompleted2.default;
exports.trackSubscriptionDetailsViewed = _trackSubscriptionDetailsViewed2.default;
exports.trackSubscriptionSale = _trackSubscriptionSale2.default;
exports.trackSubscriptionSaleAttempt = _trackSubscriptionSaleAttempt2.default;
exports.trackSubscriptionStarted = _trackSubscriptionStarted2.default;
exports.trackSubscriptionViewed = _trackSubscriptionViewed2.default;
exports.trackSubscriptionUpgraded = _trackSubscriptionUpgraded2.default;
exports.trackUpgradeCompleted = _trackUpgradeCompleted2.default;
exports.trackUpgradeStarted = _trackUpgradeStarted2.default;
exports.trackVoucherCodeApplied = _trackVoucherCodeApplied2.default;
exports.trackVoucherCodeDenied = _trackVoucherCodeDenied2.default;
exports.trackVoucherCodeEntered = _trackVoucherCodeEntered2.default;
exports.trackVoucherCodeRemoved = _trackVoucherCodeRemoved2.default;
exports.trackRaceMatrixClick = _trackRaceMatrixClick2.default;
exports.trackRacecardOfferAccordionOpened = _trackRacecardOfferAccordionOpened2.default;
exports.trackRacecardOfferAccordionClosed = _trackRacecardOfferAccordionClosed2.default;
exports.trackRacecardOfferButtonClicked = _trackRacecardOfferButtonClicked2.default;
exports.trackCardIndexClick = _trackCardIndexClick2.default;
exports.trackAllOffers = _trackAllOffers2.default;
exports.trackFreeBetsTap = _trackFreeBetsTap2.default;
exports.trackSubscriptionSaleConfirmation = _trackSubscriptionSaleConfirmation2.default;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/index.js
// module id = 1760
// module chunks = 0